var _defs, _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsIndesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.72 160.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#49021f;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#f36;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -0.2,
    width: 160.72,
    height: 161.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.91,
    y: 42.41,
    width: 17.66,
    height: 81.86,
    rx: 8.83,
    ry: 8.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.15,36.14v24.77c-1-.07-2.02-.11-3.04-.11-23.5,0-37.07,14.58-37.07,32.56s11.75,32.56,37.07,32.56c7.64,0,14.75-2.03,20.65-5.52h0s.05-.05.05-.09V36.14c0-.74-.6-1.34-1.34-1.34h-14.98c-.74,0-1.34.6-1.34,1.34ZM106.15,109.49c-1.49.4-3.05.61-4.67.61-9.72,0-17.6-7.71-17.6-17.22s7.88-17.22,17.6-17.22c1.62,0,3.18.21,4.67.61v33.21Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIndesign);
export default __webpack_public_path__ + "static/media/Icons_Indesign.e95bf1fba2018fd54db24e91b28c723a.svg";
export { ForwardRef as ReactComponent };